/**
 * Created by Alex Aguilar on 6/23/2016.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .controller('baseRatesLuggageCtrl', baseRatesLuggageCtrl)
        .controller('baseRateLuggageEditCtrl', baseRateLuggageEditCtrl);

    baseRatesLuggageCtrl.$inject = ['linkService','baseRates'];
    baseRateLuggageEditCtrl.$inject = ['baseRateService', '$stateParams','baseRate'];

    function baseRatesLuggageCtrl(linkService,baseRates){
        var vm = this;
        vm.linkService = linkService;

        vm.baseRates = (baseRates.data._embedded) ? baseRates.data._embedded.baserates : [];
        vm.pages = baseRates.data.page;
        vm.searchRecords = "";
    }

    function baseRateLuggageEditCtrl(baseRateService, $stateParams, baseRate){
        var vm = this;
        vm.baseRate = baseRate.data;

        vm.saveBaseRatLuggage = function(isValid, baseRate){
            if(isValid){
                baseRateService.updateBaseRate($stateParams.id, baseRate, 'baseRatesLuggage');
            }
        }
    }
})();
